import moment from 'moment';
import 'moment/locale/pt-br';

import { DATE_FORMAT_CHARS } from '@cordel/helpers/form/validators/date';

moment.locale('pt-br');
moment.suppressDeprecationWarnings = true;

export default function dateize(value = '', options = {}) {
  if (!value) {
    return undefined;
  }

  let result;

  try {
    result = moment(value, /\d{2}\/\d{2}\/\d{4}$/.test(value) ? DATE_FORMAT_CHARS : options.format);
  } catch (err) { /* */ }

  if (result && result.isValid()) {
    return result.format(options.output || DATE_FORMAT_CHARS);
  }

  return undefined;
}

export function international(value = '', options = {}) {
  if (!value) {
    return undefined;
  }

  return moment(
    dateize(value, {
      format: DATE_FORMAT_CHARS,
      ...options,
    }),
    options.output || DATE_FORMAT_CHARS,
  ).format('YYYY-MM-DD');
}
